
















import {Vue, Component, Watch} from 'vue-property-decorator';
import PagedTable from '@/components/Views/Dashboard/PagedTable.vue';
import {nil} from '@/common';
@Component({
    components: {
        PagedTable,
    },
})
export default class DashboardApplications extends Vue {
    public headers = [
        {
            text: 'Link',
            value: '',
            sortable: true,
            html(item) { return `<a href="/dashboard/applications/${item._id}">View Application</a>`; },
        },
        {
            text: 'Phone',
            value: 'phone',
            sortable: true,
            html(item) { return `<a href="tel:${item.phone}">${item.phone}</a>`; },
        },
        {
            text: 'First Name',
            value: 'firstName',
            sortable: true,

        },
        {
            text: 'Last Name',
            value: 'lastName',
            sortable: true,
        },
        {
            text: 'Email',
            value: 'email',
            sortable: true,
            html(item) { return `<a href="mailto:${item.email}">${item.email}</a>`; },
        },
        {
            text: 'Address',
            value: 'address',
            sortable: true,
            html(item) { return `${item.address} ${item.address2}<br/> ${item.city} ${item.state} ${item.zip}`; },
        },
    ];
    @Watch('search')
    private onSearchChanged(value: string, oldValue: string) {
        (this.$refs.table as any).refresh(true);
    }
    public search = '';
    private get searchQuery() {
        return nil(this.search) || this.search === '' ? undefined : {
            $or: [
                {firstName: {$search: this.search.toString()}},
                {lastName: {$search: this.search.toString()}},
                {email: {$search: this.search.toString()}},
            ],
        };
    }
    private onQuery() {
        return {
            ...this.searchQuery,
        };
    }
}
